import request from "@/utils/request";
import qs from "qs";

function getData(data) {
  const formData = new FormData();
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    formData.append(keys[i], data[keys[i]]);
  }
  return formData;
}

/**
 * 查询专栏单元
 *
 */
export function getColumnPartitions(columnId) {
  return request({
    url: `api/v2/columns/${columnId}/partition`,
    method: "get",
  });
}

/**
 * 查询单元课程
 */
export function getColumnPartitionCourses(columnId, params) {
  return request.get(`api/v2/columns/${columnId}/partition/teacher2`, {
    params,
  });
}

/**
 * 查询专栏学员
 *
 */
export function getColumnMembers(params) {
  return request.get("api/v3/members/column_members", { params });
}

/**
 * 查询专栏列表
 *
 */
export function getColumnList(params) {
  return request.get("api/v3/column_hybrid/douyin/get_column_list", { params });
}

// 查询专栏列表
export function getColumns(params) {
  return request.get("api/v2/columns/list_columns_page", { params });
}

export function setColumnShelf(columnId, status) {
  return request({
    url: `/api/v2/columns/${columnId}/shelf`,
    method: "post",
    data: getData({ status }),
  });
}

/**
 * 查询专栏详情
 *
 */
export function getColumnDetail(columnId, params) {
  return request({
    url: `api/v2/columns/${columnId}`,
    method: "get",
    params: params,
  });
}

export function getHybridColumnDetail(params) {
  return request({
    url: `api/v3/column_hybrid/douyin/findColumnsHybridByColumnId`,
    method: "get",
    params: params,
  });
}

/**
 * 创建专栏
 *
 */
export function createColumn(data) {
  return request({
    url: "/api/v3/column_hybrid/douyin/column_create",
    method: "post",
    data: getData(data),
  });
}

export function addColumn(data) {
  return request({
    url: `/api/v2/columns/create`,
    method: "post",
    data: getData(data),
  });
}

export function updateColumn(id, data) {
  return request({
    url: `/api/v2/columns/${id}/update`,
    method: "post",
    data: getData(data),
  });
}

export function copyColumn(data) {
  return request({
    url: `/api/v2/columns/copy`,
    method: "post",
    data: getData(data),
  });
}

export function updateColumnBackground(id, data) {
  return request({
    url: `/api/v2/columns/${id}/updateBackground`,
    method: "post",
    data: getData(data),
  });
}

export function updateColumnTitle(id, data) {
  return request({
    url: `/api/v2/columns/${id}/updateTitle`,
    method: "post",
    data: getData(data),
  });
}

export function updateColumnPrice(id, data) {
  return request({
    url: `/api/v2/columns/${id}/updatePrice`,
    method: "post",
    data: getData(data),
  });
}

export function updateActivityBackground(id, data) {
  return request({
    url: `/api/v3/activities/${id}/updateBackground`,
    method: "post",
    data: getData(data),
  });
}

export function updateActivityTitle(id, data) {
  return request({
    url: `/api/v3/activities/${id}/updateTitle`,
    method: "post",
    data: getData(data),
  });
}

export function updateActivityPrice(id, data) {
  return request({
    url: `/api/v3/activities/${id}/updatePrice`,
    method: "post",
    data: getData(data),
  });
}

export function createActivity(data) {
  return request({
    url: `/api/v3/activities/create`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function createActivity2(data) {
  return request({
    url: `/api/v3/activities/create2`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function deleteActivity(aid) {
  return request({
    url: `/api/v3/activities/${aid}/delete`,
    method: "post",
  });
}

export function updateActivity(id, data) {
  return request({
    url: `/api/v3/activities/${id}/update`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function getActivityDetail(aid) {
  return request({
    url: `/api/v3/activities/${aid}`,
    method: "get",
  });
}

export function addActivities(column_id, data) {
  return request({
    url: `/api/v2/columns/${column_id}/add_activities2`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function addActivities2(column_id, data) {
  return request({
    url: `/api/v2/columns/${column_id}/add_activities2`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function moveActivities(column_id, data) {
  return request({
    url: `/api/v2/columns/${column_id}/update_partition`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function transferActivities(column_id, data) {
  return request({
    url: `/api/v2/columns/${column_id}/partition/activity_transfer`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function sendUploadVideoInfo(data) {
  return request({
    url: `https://stream.renrenjiang.cn/stream/notice/upload_metadata?metadata=%7B%22activity_id%22:${data.activity_id},%22autoPublish%22:0,%22horizontal%22:1%7D`,
    method: "post",
  });
}

// 初始化单元产生默认列表
export async function getPartitionInit(columnId) {
  return request.get(`api/v2/columns/${columnId}/partition/teacher1`);
}

export async function getColumnStatus(params) {
  return request.get(`/api/v3/column_hybrid/douyin/get_column_status`, {
    params,
  });
}

export async function updateShelfStatus(id, data) {
  return request({
    url: `api/v3/column_hybrid/douyin/${id}/set_column_shelf?shelfStatus=${data.shelfStatus}`,
    method: "post",
  });
}

export async function updateAllShelfStatus(ids, data) {
  return request({
    url: `api/v3/column_hybrid/douyin/set_column_batch_shelf?columnIds=${ids}&shelfStatus=${data.shelfStatus}`,
    method: "post",
  });
}

export async function getStreamUrl(aid, tid) {
  return request.get(`/api/v3/activities/${aid}/stream_url?user_id=${tid}`);
}

/**
 * 更新专栏
 */
export async function columnUpdate(columnId, data) {
  return request({
    url: `/api/v3/column_hybrid/douyin/${columnId}/column_update`,
    method: "post",
    data: getData(data),
  });
}

export async function deleteCourse(Id) {
  return request({
    url: `/api/v3/activities/${Id}/delete/`,
    method: "post",
  });
}

export async function removeCourse(Id, data) {
  return request({
    url: `/api/v2/columns/${Id}/remove_activity`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function getActivity(aid) {
  return request.get(`/api/v2/activities/${aid}`);
}

export async function getActivityColumn(aid) {
  return request.get(`/api/v3/activities/${aid}/columns`);
}

export async function recognizeImageBase64(data) {
  return request({
    url: `/api/v3/column_hybrid/recognizeImageBase64`,
    method: "post",
    headers: {
      "Content-Type": "application/octet-stream", // 或者根据你的数据类型选择合适的Content-Type
    },
    data: data,
    raw: true,
  });
}

export async function deletePartition(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/delete`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function createPartition(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/create`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function updatePartition(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/update`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function sortPartition(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/sort`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function moveUnitCourse(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/activity_transfer`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function sortActivity(id, data) {
  return request({
    url: `/api/v2/columns/${id}/partition/activity_sort`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function getActivityInPartition(id, params) {
  return request.get(`/api/v2/columns/${id}/partition/activitiesNew`, {
    params,
  });
}

export async function createKS(userId, data) {
  return request({
    url: `/api/v3/column_hybrid/${userId}/create`,
    method: "post",
    data: qs.stringify(data),
  });
}

export async function getTeacherColumns(params) {
  return request.get(`/api/v2/columns/list_columns_page`, {
    params,
  });
}

export async function xhsProductAdd2(data) {
  return request({
    url: `/api/v3/column_hybrid/xhs/productAdd2`,
    method: "post",
    data: data,
  });
}

export async function sphProductAdd2(data) {
  return request({
    url: `/api/v3/column_hybrid/sph/productAdd2`,
    method: "post",
    data: data,
  });
}

export async function dyProductAdd2(data) {
  return request({
    url: `/api/v3/column_hybrid/doudian/productAdd2`,
    method: "post",
    data: data,
  });
}

export async function doudianProductAdd2(data) {
  return request({
    url: `/api/v3/doudian/core/createProduct`,
    method: "post",
    data: data,
  });
}

// 绑定群
export function bindPlanetAndGroup(data) {
  return request({
    url: `/api/v4/planet/dy/fans/group/bindPlanetAndGroup`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function unbindPlanetAndGroup(data) {
  return request({
    url: `/api/v4/planet/dy/fans/group/unbindPlanetAndGroup`,
    method: "post",
    data: qs.stringify(data),
  });
}

// 获取抖音群
export function getDouyinGroupList(params) {
  return request.get("/api/v4/planet/dy/fans/group/findFansGroupList", {
    params,
  });
}

export function getDyGroupInfo(params) {
  return request.get("/api/v4/planet/dy/fans/group/getDyGroupInfo", {
    params,
  });
}

export function bindColumnGroup(data) {
  return request({
    url: `/api/v2/columns/bindGroup`,
    method: "post",
    data: qs.stringify(data),
  });
}

export function getBindColumnGroup(params) {
  return request.get(`/api/v2/columns/getBindGroup`, { params });
}

export function getEvaluatesList(id, params) {
  return request.get(`/api/v3/orders/${id}/evaluates_list`, { params });
}

export function getUserEvaluatesList(params) {
  return request.get(`/api/v3/orders/user_evaluates`, { params });
}

export function replyEvaluates(id, params) {
  return request({
    url: `/api/v3/orders/${id}/reply_evaluates`,
    method: "post",
    data: getData(params),
  });
}

export function hideEvaluates(id) {
  return request({
    url: `/api/v3/orders/${id}/hide_evaluates`,
    method: "post",
  });
}

export function showEvaluates(id) {
  return request({
    url: `/api/v3/orders/${id}/show_evaluates`,
    method: "post",
  });
}

export function randomRobotUserEvaluatesColumn(data) {
  return request({
    url: `/api/v3/orders/randomRobotUserEvaluatesColumn`,
    method: "post",
    data: getData(data),
  });
}

export function publishActivities(id) {
  return request({
    url: `/api/v3/activities/${id}/publish`,
    method: "post",
  });
}

export function getUserVideos(params) {
  return request.get(`/api/v2/users/videos`, { params });
}

export function getUserHybridColumns(userId, params) {
  return request.get(
    `/api/v3/column_hybrid/${userId}/find_column_list_hybrid`,
    { params }
  );
}

export function getUserDoudianColumns(params) {
  return request.get(`/api/v3/doudian/get_temp_product_list`, { params });
}

export function getDoudianShopList() {
  return request.get(`/api/v3/doudian/shop_list`);
}

export function getSourceCategorys(type) {
  return request.get(`/api/v3/column_hybrid/source/${type}/getCategorys`);
}

export function createSourceCategory(params) {
  return request({
    url: `/api/v3/column_hybrid/source/createCategory`,
    method: "post",
    data: getData(params),
  });
}

export function getQuestCategorys(type) {
  return request.get(`/api/v3/column_hybrid/quest/${type}/getCategorys`);
}

export function createQuestCategory(params) {
  return request({
    url: `/api/v3/column_hybrid/quest/createCategory`,
    method: "post",
    data: getData(params),
  });
}

export function replaceSource(params) {
  return request({
    url: `/api/v3/column_hybrid/source/picture/replaceSource`,
    method: "post",
    data: getData(params),
  });
}

// 上传素材
export function uploadSource(categoryId, type, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("info", "{}");
  formData.append("categoryId", categoryId);

  return request.post(
    `/api/v3/column_hybrid/source/${type}/uploadSource`,
    formData
  );
}

// 上传图片素材
export function uploadPictureSource(categoryId, type, file, info) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("info", info);
  formData.append("categoryId", categoryId);

  return request.post(
    `/api/v3/column_hybrid/source/${type}/uploadSource`,
    formData
  );
}

// 查询素材列表
export function getSources(type, params) {
  console.log("getSources", params);
  return request.get(
    `/api/v3/column_hybrid/source/${type}/findSources`,
    params
  );
}

// 修改素材名称
export function updateSource(id, params) {
  return request({
    url: `/api/v3/column_hybrid/source/${id}/updateSource`,
    method: "post",
    data: getData(params),
  });
}

// 修改素材名称
export function updateVodSource(id, params) {
  params.target_type = "video";
  return request({
    url: `/api/v3/column_hybrid/source/${id}/updateSource`,
    method: "post",
    data: getData(params),
  });
}

// 修改素材名称
export function updateCategorySource(id, params) {
  return request({
    url: `/api/v3/column_hybrid/source/${id}/updateCategorySource`,
    method: "post",
    data: getData(params),
  });
}

// 修改素材名称
export function updateCategoryVodSource(id, params) {
  params.target_type = "video";
  return request({
    url: `/api/v3/column_hybrid/source/${id}/updateCategorySource`,
    method: "post",
    data: getData(params),
  });
}

// 删除素材
export function deleteSource(id) {
  return request({
    url: `/api/v3/column_hybrid/source/${id}/deleteSource`,
    method: "post",
  });
}

// 删除素材
export function deleteVodSource(id) {
  return request({
    url: `/api/v3/column_hybrid/source/${id}/deleteSource`,
    method: "post",
  });
}

// 查询素材资源使用情况
export function getSourceDetail() {
  return request.get(`/api/v3/column_hybrid/source/getSourceDetail`);
}

// 提交抖音店铺
export function createDyGoods(params) {
  return request({
    url: `/api/v3/doudian/core/createBookProduct`,
    method: "post",
    data: params,
  });
}

// 修改抖音商品价格
export function changeDyPrice(params) {
  return request({
    url: `/api/v3/doudian/core/changePrice`,
    method: "post",
    data: getData(params),
  });
}

// 上架抖音商品
export function upShelfDyGoods(params) {
  return request({
    url: `/api/v3/doudian/core/onlineProduct`,
    method: "post",
    data: getData(params),
  });
}

// 下架抖音商品
export function downShelfDyGoods(params) {
  return request({
    url: `/api/v3/doudian/core/offlineProduct`,
    method: "post",
    data: getData(params),
  });
}

// 上架视频号商品
export function upShelfSphGoods(params) {
  return request({
    url: `/api/v3/shipinhao/core/productListingAuto`,
    method: "post",
    data: getData(params),
  });
}

// 下架视频号商品
export function downShelfSphGoods(params) {
  return request({
    url: `/api/v3/shipinhao/core/productDelistingAuto`,
    method: "post",
    data: getData(params),
  });
}

// 上架小红书商品
export function upShelfXhsGoods(params) {
  return request({
    url: `/api/v3/column_hybrid/xhs/productListing`,
    method: "post",
    data: getData(params),
  });
}

// 当前讲师的小红书默认店铺
export function getXhsTeacherShop(userId) {
  return request.get(`/api/v3/column_hybrid/xhs/teacherShopByUserId`, {
    params: { userId },
  });
}

// 小红书店铺选项(全部生效店铺,讲师页下拉用)
export function getXhsShopOptions() {
  return request.get(`/api/v3/xhs/core/shop/list`);
}

// 下架小红书商品
export function downShelfXhsGoods(params) {
  return request({
    url: `/api/v3/column_hybrid/xhs/productDelisting`,
    method: "post",
    data: getData(params),
  });
}

// 修改抖音商品库存
export function updateDyGoodsStock(params) {
  return request({
    url: `/api/v3/doudian/core/updateSkuStockNum`,
    method: "post",
    data: getData(params),
  });
}

// 修改视频号商品库存&价格
export function updateSphGoodsStockPrice(params) {
  return request({
    url: `/api/v3/shipinhao/core/free/updateSku`,
    method: "post",
    data: getData(params),
  });
}

// 修改小红书商品库存&价格
export function updateXhsGoodsStockPrice(params) {
  return request({
    url: `/api/v3/column_hybrid/xhs/updateSku`,
    method: "post",
    data: getData(params),
  });
}

// 提交快手店铺
export function createKsGoods(params) {
  return request({
    url: `/api/v3/kuaishou/shop/addProduct`,
    method: "post",
    data: params,
  });
}

// 修改快手商品库存
export function updateKsGoodsStock(params) {
  return request({
    url: `/api/v3/kuaishou/shop/productStockUpdate`,
    method: "post",
    data: getData(params),
  });
}

// 修改快手商品价格
export function updateKsGoodsPrice(params) {
  return request({
    url: `/api/v3/kuaishou/shop/productPriceUpdate`,
    method: "post",
    data: getData(params),
  });
}

// 修改快手商品上架状态
export function updateKsGoodsShelves(params) {
  return request({
    url: `/api/v3/kuaishou/shop/productShelves`,
    method: "post",
    data: getData(params),
  });
}

// 获取播放信息
export function getPlaySign(videoId) {
  return request.get(`/api/v3/column_hybrid/source/${videoId}/getPlaySign`);
}

// 查询用户标签列表
export function getUserMarkerList(params) {
  return request.get(`/api/v3/teacher_hybrid/findMarkers`, { params });
}

// 查询用户标签
export function getUserMarker(id) {
  return request.get(`/api/v3/teacher_hybrid/${id}/showMarker`);
}

// 创建标签
export function createUserMarker(params) {
  return request({
    url: `/api/v3/teacher_hybrid/createMarker`,
    method: "post",
    data: getData(params),
  });
}

// 修改标签
export function updateUserMarker(id, params) {
  return request({
    url: `/api/v3/teacher_hybrid/${id}/updateMarker`,
    method: "post",
    data: getData(params),
  });
}

// 删除标签
export function deleteUserMarker(id) {
  return request({
    url: `/api/v3/teacher_hybrid/${id}/deleteMarker`,
    method: "post",
  });
}

// 打标签
export function setUserMarker(userId, params) {
  return request({
    url: `/api/v3/teacher_hybrid/${userId}/setMarker`,
    method: "post",
    data: getData(params),
  });
}

// 移除标签
export function cancelMarker(userId, params) {
  return request({
    url: `/api/v3/teacher_hybrid/${userId}/setMarker`,
    method: "post",
    data: getData(params),
  });
}

// 绑定达人百应ID
export function updateBuyin(params) {
  return request({
    url: `/api/v3/teacher_hybrid/updateConfBuyin`,
    method: "post",
    data: getData(params),
  });
}

// 创建抖店专属推广策略
export function createDoudianStrategy(params) {
  return request({
    url: `/api/v3/doudian/core/createStrategy`,
    method: "post",
    data: getData(params),
  });
}

// 创建打卡
export function createPunch(params) {
  return request({
    url: `/api/v3/column_hybrid/punch/createPunch`,
    method: "post",
    data: getData(params),
  });
}

// 查询打卡列表
export function getPunchs(params) {
  return request.get(`/api/v3/column_hybrid/punch/findPunchs`, { params });
}

export function deletePunch(id) {
  return request({
    url: `/api/v3/column_hybrid/punch/${id}/deletePunch`,
    method: "post",
  });
}

export function updatePunchBackground(id, data) {
  return request({
    url: `/api/v3/column_hybrid/punch/${id}/updatePunchBackground`,
    method: "post",
    data: getData(data),
  });
}

export function updatePunchTitle(id, data) {
  return request({
    url: `/api/v3/column_hybrid/punch/${id}/updatePunchTitle`,
    method: "post",
    data: getData(data),
  });
}

export function updatePunchPrice(id, data) {
  return request({
    url: `/api/v3/column_hybrid/punch/${id}/updatePunchPrice`,
    method: "post",
    data: getData(data),
  });
}

// 查询打卡详情
export function getPunchDetail(id) {
  return request.get(`/api/v3/column_hybrid/punch/${id}/showPunch`);
}

// 创建打卡任务
export function createPunchTask(params) {
  return request({
    url: `/api/v3/column_hybrid/punch/createPunchTask`,
    method: "post",
    data: getData(params),
  });
}

// 查询打卡任务列表
export function getPunchTasks(params) {
  return request.get(`/api/v3/column_hybrid/punch/findPunchTasks`, { params });
}

// 查询打卡成员列表
export function getPunchMembers(params) {
  return request.get(`/api/v3/column_hybrid/punch/findPunchMembers`, {
    params,
  });
}

// 查询打卡动态列表
export function findPunchDynamics(params) {
  return request.get(`/api/v3/column_hybrid/punch/findPunchDynamics`, {
    params,
  });
}

// 设置动态置顶
export function setPunchDynamicTop(params) {
  return request({
    url: `/api/v3/column_hybrid/punch/setPunchDynamicsTop`,
    method: "post",
    data: getData(params),
  });
}

// 设置动态加精
export function setPunchDynamicExcellent(params) {
  return request({
    url: `/api/v3/column_hybrid/punch/setPunchDynamicsExcellent`,
    method: "post",
    data: getData(params),
  });
}

// 评论动态
export function createPunchDynamicComment(dynamicId, params) {
  return request({
    url: `/api/v3/column_hybrid/punch/${dynamicId}/createComment`,
    method: "post",
    data: getData(params),
  });
}

// 查询动态评论列表
export function findDynamicComments(dynamicId, params) {
  return request.get(`/api/v3/column_hybrid/punch/${dynamicId}/findComments`, {
    params,
  });
}

export function documentBindColumns(documentIds, columnIds) {
  return request({
    url: `/api/v3/document/bind/columns`,
    method: "post",
    data: getData({ documentIds, columnIds }),
  });
}

export function documentUnbindColumns(documentIds, columnIds) {
  return request({
    url: `/api/v3/document/unbind/columns`,
    method: "post",
    data: getData({ documentIds, columnIds }),
  });
}

export function documentBindActivitys(documentIds, activityIds) {
  return request({
    url: `/api/v3/document/bind/activitys`,
    method: "post",
    data: getData({ documentIds, activityIds }),
  });
}

export function documentUnbindActivitys(documentIds, activityIds) {
  return request({
    url: `/api/v3/document/unbind/activitys`,
    method: "post",
    data: getData({ documentIds, activityIds }),
  });
}

// 核销订单
export function verifyOrder(params) {
  return request({
    url: `/api/v3/doudian/core/verifyCoupon`,
    method: "post",
    data: getData(params),
  });
}

// 查询讲师对应抖店 getShopIdByUserId
export function getShopIdByUserId(params) {
  return request.get(`/api/v3/doudian/core/getShopIdByUserId`, {
    params,
  });
}

// 查询视频id对应的视频信息
export function getVideoInfoById(videoId) {
  return request.get(`/api/v1/videos/info?video_id=${videoId}`);
}

// 课程绑定视频
export function bindVideoToActivity(params) {
  return request({
    url: `/api/v3/activities/relativeVideo`,
    method: "post",
    data: getData(params),
  });
}

export function addLimitUser(columnId, params) {
  return request({
    url: `/adm/column/${columnId}/members/addLimitUser`,
    method: "post",
    params,
  });
}

export function renameDocument(params) {
  return request({
    url: `/api/v3/document/rename`,
    method: "post",
    params,
  });
}

export function getDoudianDetail(params) {
  return request.get(`/adm/doudian/income/detail`, {
    params,
  });
}

export function teacherShopNo(params) {
  return request.get(`/api/v3/column_hybrid/sph/teacherShopNo`, {
    params,
  });
}

export function getRRJServiceProductList(params) {
  return request.get(`/api/v3/RRJService/productList`, {
    params,
  });
}

export function createKSCourse(data) {
  return request({
    url: `/api/v3/column_hybrid/ks/createCourse?columnId=${data.columnId}&introduce=${data.introduce}&categoryId=${data.categoryId}`,
    method: "post",
  });
}

export function submitKSCourse(data) {
  return request({
    url: `/api/v3/column_hybrid/ks/submitCourse?courseId=${data.courseId}`,
    method: "post",
  });
}

export function findCourseDetail(courseId) {
  return request({
    url: `/api/v3/column_hybrid/ks/findCourseDetail?courseId=${courseId}`,
    method: "get",
  });
}

export function updateKsStatus(data) {
  return request({
    url: `/api/v3/column_hybrid/ks/updateStatus?courseIds=${data.courseId}&status=${data.status}`,
    method: "post",
  });
}

export function setCourseOnlineStatus(courseId) {
  return request({
    url: `/api/v3/column_hybrid/ks/setCourseOnlineStatus?courseId=${courseId}&onlineStatus=online`,
    method: "post",
  });
}

// 查询视频绑定的课程
export function findActivityListByVideoId(courseId) {
  return request({
    url: `/api/v2/videos/findActivityListByVideoId?video_id=${courseId}`,
    method: "get",
  });
}

// 删除视频素材
export function onlyDeleteVideo(courseId) {
  return request({
    url: `/adm/activity/videos/${courseId}/onlyDelete`,
    method: "post",
  });
}
